export default "__VITE_ASSET__DopWUVfk__"